var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6891_179633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67733 51.4325H29V49.5611H4.67733C3.12744 49.5611 1.87088 48.3045 1.87088 46.7547V5.59334C1.87088 4.04299 3.12744 2.7869 4.67733 2.7869H45.8386C47.3892 2.7869 48.6451 4.04299 48.6451 5.59334V27.1093H50.5164V5.59334C50.5134 3.01129 48.4209 0.919064 45.8386 0.916016H4.67733C2.09575 0.919064 0.00328266 3.01129 0 5.59334V46.7547C0.00328266 49.3367 2.09575 51.4289 4.67733 51.4325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73438 4.6582H5.60502V6.52885H3.73438V4.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48438 4.6582H9.35573V6.52885H7.48438V4.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2188 4.6582H13.0899V6.52885H11.2188V4.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73438 8.40039H46.7663V10.2717H3.73438V8.40039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3757 12.416L10.9995 14.7922C8.99102 13.4625 6.30135 13.8705 4.77702 15.736C3.25293 17.6012 3.38963 20.3183 5.09286 22.0213C6.79586 23.725 9.5132 23.8617 11.3787 22.3374C13.2439 20.8133 13.6522 18.1232 12.3222 16.1151L14.6982 13.7389L13.3757 12.416ZM8.42383 21.4966C6.87418 21.4966 5.61762 20.2402 5.61762 18.6904C5.61762 17.1402 6.87418 15.8841 8.42383 15.8841C8.84119 15.8856 9.25176 15.9812 9.62622 16.1643L7.76284 18.028L9.08528 19.3509L10.9501 17.4884C11.1332 17.8627 11.2291 18.2732 11.2305 18.6904C11.2305 20.2402 9.97442 21.4966 8.42383 21.4966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 15.8848H31.8091V17.7554H15.9062V15.8848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 19.625H22.4545V21.4956H15.9062V19.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3281 19.625H37.4245V21.4956H24.3281V19.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6719 15.8848H43.0268V17.7554H33.6719V15.8848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3757 23.6426L10.9995 26.0188C8.99102 24.689 6.30135 25.097 4.77702 26.9625C3.25293 28.828 3.38963 31.5449 5.09286 33.2484C6.79586 34.9516 9.5132 35.0883 11.3787 33.564C13.2439 32.0396 13.6522 29.3504 12.3222 27.3417L14.6982 24.9655L13.3757 23.6426ZM8.42383 32.7234C6.87418 32.7234 5.61762 31.4668 5.61762 29.9169C5.61762 28.3668 6.87418 27.1102 8.42383 27.1102C8.84119 27.1119 9.25176 27.2078 9.62622 27.3909L7.76284 29.255L9.08528 30.5774L10.9501 28.7148C11.1332 29.0892 11.2291 29.4998 11.2305 29.9169C11.2305 31.4668 9.97442 32.7234 8.42383 32.7234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 27.1074H31.8091V28.9785H15.9062V27.1074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 30.8496H22.4545V32.7205H15.9062V30.8496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3281 30.8496H31.8117V32.7205H24.3281V30.8496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6719 27.1074H37.4136V28.9785H33.6719V27.1074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3757 34.8652L10.9995 37.2414C8.99102 35.9117 6.30135 36.3197 4.77702 38.1852C3.25293 40.0507 3.38963 42.7675 5.09286 44.471C6.79586 46.1745 9.5132 46.3107 11.3787 44.7866C13.2439 43.2623 13.6522 40.5728 12.3222 38.5641L14.6982 36.1881L13.3757 34.8652ZM8.42383 43.946C6.87418 43.946 5.61762 42.6895 5.61762 41.1396C5.61762 39.5895 6.87418 38.3331 8.42383 38.3331C8.84119 38.3345 9.25176 38.4302 9.62622 38.6136L7.76284 40.4777L9.08528 41.8001L10.9501 39.9374C11.1332 40.3119 11.2291 40.7227 11.2305 41.1396C11.2305 42.6895 9.97442 43.946 8.42383 43.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 38.334H28.0673V40.2053H15.9062V38.334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 42.0762H22.4545V43.9471H15.9062V42.0762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3281 42.0762H28.0699V43.9471H24.3281V42.0762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9699 57.0434C51.7201 57.0434 58.0019 50.7604 58.0019 43.011C58.0019 35.2608 51.7201 28.9785 43.9699 28.9785C36.2198 28.9785 29.9375 35.2608 29.9375 43.011C29.9466 50.7569 36.2236 57.034 43.9699 57.0434ZM43.9699 30.8496C50.686 30.8496 56.1313 36.2944 56.1313 43.011C56.1313 49.7275 50.686 55.1721 43.9699 55.1721C37.2532 55.1721 31.8081 49.7275 31.8081 43.011C31.8161 36.2977 37.2562 30.8571 43.9699 30.8496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2684 43.5297L36.5938 44.3658L38.4649 48.1078C38.599 48.377 38.855 48.5653 39.1521 48.6133C39.2004 48.6208 39.2487 48.6248 39.2973 48.6255C39.5451 48.6255 39.7831 48.5268 39.9589 48.3514L51.1843 37.1256L49.8618 35.8027L39.5533 46.1108L38.2684 43.5297Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6891_179633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.afe9dd7828f5a656f8cfa835acc576df.svg";
export { ForwardRef as ReactComponent };